import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
  ScheduledJobConfigResponse,
  ScheduledJobConfigRequest,
  ScheduledJobExecutionResponse,
  ScheduledJobEnabledRequest,
} from '../models/scheduled-job.model';

@Injectable({ providedIn: 'root' })
export class ScheduledJobApiService {
  private baseUrl = `${environment.apiUrl}api/scheduled-jobs`;

  constructor(private http: HttpClient) {}

  list(jobKey?: string): Observable<ScheduledJobConfigResponse[]> {
    let params = new HttpParams();
    if (jobKey) {
      params = params.set('jobKey', jobKey);
    }
    return this.http.get<ScheduledJobConfigResponse[]>(this.baseUrl, { params });
  }

  getById(id: number): Observable<ScheduledJobConfigResponse> {
    return this.http.get<ScheduledJobConfigResponse>(`${this.baseUrl}/${id}`);
  }

  create(req: ScheduledJobConfigRequest): Observable<ScheduledJobConfigResponse> {
    return this.http.post<ScheduledJobConfigResponse>(this.baseUrl, req);
  }

  update(id: number, req: ScheduledJobConfigRequest): Observable<ScheduledJobConfigResponse> {
    return this.http.put<ScheduledJobConfigResponse>(`${this.baseUrl}/${id}`, req);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }

  setEnabled(id: number, enabled: boolean): Observable<ScheduledJobConfigResponse> {
    const body: ScheduledJobEnabledRequest = { enabled };
    return this.http.patch<ScheduledJobConfigResponse>(`${this.baseUrl}/${id}/enabled`, body);
  }

  runNow(id: number): Observable<ScheduledJobExecutionResponse> {
    return this.http.post<ScheduledJobExecutionResponse>(`${this.baseUrl}/${id}/run-now`, {});
  }

  getExecutions(
    jobConfigId: number,
    page = 0,
    size = 20,
  ): Observable<{
    content: ScheduledJobExecutionResponse[];
    totalElements: number;
    totalPages: number;
    page: number;
    size: number;
    hasNext: boolean;
    hasPrevious: boolean;
  }> {
    const params = new HttpParams().set('page', page).set('size', size);
    return this.http.get<any>(`${this.baseUrl}/${jobConfigId}/executions`, { params });
  }
}
